var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#657695;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-325 -18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(315 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(10 10)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(10 3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(10 17)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(10 10)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(10 3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(10 17)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/drag_icon.655f44b8.svg";
export { ForwardRef as ReactComponent };